// Portfolio.js
import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Lenis from '@studio-freight/lenis';

import Navbar from './navbar.js';

import ProcessSection from './ProcessSection.js';
import Reels from './reels.js';
import GallerySection from './gallery.js';
import HomeSection from './mainHome.js';
import Service from './service copy.js';
import Services from './ServiceSlider.js';

import ContactSection from "./ContactSection";
import TestimonialSection from './TestimonialSection.js';
import ClientSection from "./ClientSection";
import ClientD2 from "./ClientSectionD-2"
import Number from "./numbers";

function Portfolio() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
      smoothTouch: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <>

       
       <style>
      {`
        .tight-section {
          margin: 0 !important;
          padding: 0 !important;
        }

        .tight-section > * {
          margin-top: -100px !important;
          margin-bottom: -100px !important;
          padding-top: 0 !important;
          padding-bottom: 0 !important;

        }
           .tight2-section > * {
       
          margin-bottom: -100px !important;
          padding-top: 0 !important;
          padding-bottom: 0 !important;

        }

          @media (max-width: 768px) {
    .tight-section > * {
      margin-top: -40px !important;
      margin-bottom: -40px !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

     .tight2-section > * {
      margin-top: -40px !important;
      margin-bottom: -40px !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
      .bot-section{
      margin-bottom: -150px !important;
      }
      
   
      `}
    </style>
  
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <HomeSection />
             <Service/>
              <Reels />
              <ProcessSection />
              <TestimonialSection />
               <Number></Number>
              <br></br>
           
                <div className="tight2-section">
              <GallerySection />
              </div>
           

               <ClientD2/>
                
                <div className="bot-section">
        <ClientSection />
        </div>
        

        <div className="tight-section">
              <ContactSection />
              </div>
            </>
          }
        />

        {/* Portfolio page */}
        <Route path="/portfolio" element={<GallerySection />} />

        {/* Other pages */}
        <Route path="/services" element={<Services />} />
        <Route path="/blog" element={<h2>Blog Page Coming Soon...</h2>} />
        <Route path="/case-studies" element={<h2>Case Studies Page</h2>} />
        <Route path="/contact" element={<ContactSection />} />
      </Routes>
    </>
  );
}

export default Portfolio;
